import { Wallpaper } from "@repo/ui/components/wallpaper"

function BeakerLogo({ className }: { className?: string }) {
  return (
    <svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      strokeWidth={1}
      role="img"
      aria-label="Laydown Labs"
      className={className}
    >
      <path
        d="M0.5 12.5049H12.5V10.5049L10.5 7.50488H2.5L0.5 10.5049V12.5049Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M4.5 0.504883H8.5V4.20211C8.5 4.39953 8.55844 4.59254 8.66795 4.75681L12.2422 10.1181C12.4103 10.3703 12.5 10.6666 12.5 10.9697C12.5 11.8176 11.8127 12.5049 10.9648 12.5049H2.03518C1.18733 12.5049 0.5 11.8176 0.5 10.9697C0.5 10.6666 0.589713 10.3703 0.757834 10.1181L4.33205 4.75681C4.44156 4.59254 4.5 4.39953 4.5 4.20211V0.504883Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 7.50488H10.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.50488 0.5L3.50488 0.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FullScreenLoader() {
  return (
    <div className="dark">
      <Wallpaper color="blue" className="min-h-svh flex items-center justify-center">
        <div className="flex flex-col items-center gap-5">
          <div className="relative flex items-center justify-center">
            <div className="absolute size-12 rounded-full border dark:border-white/25 border-black/25 animate-[loader-ring_2.4s_ease-in-out_infinite]" />
            <BeakerLogo className="relative size-5 text-white/70" />
          </div>
          <p className="font-display text-sm font-semibold tracking-tight text-white/60">
            Laydown<span className="text-primary">Labs</span>
          </p>
        </div>
      </Wallpaper>
    </div>
  )
}
